interface Props {
	className?: string;
}

// Placeholder cursive scribble for a witness; distinct from investor (warmer
// ink #2a1a1a) so slots are tellable apart. ViewBox 100x40, caller sizes.
export const WitnessCursive = ({ className }: Props) => (
	<svg
		className={className}
		viewBox="0 0 100 40"
		xmlns="http://www.w3.org/2000/svg"
		preserveAspectRatio="xMidYMid meet"
		data-testid="scribble-witness-cursive"
	>
		<path
			d="M8 24 Q 12 8, 18 22 T 30 24 Q 36 36, 42 22 Q 48 8, 54 24 Q 62 34, 70 18 Q 76 8, 82 24 Q 88 32, 94 20"
			stroke="#2a1a1a"
			strokeWidth="1.4"
			strokeLinecap="round"
			strokeLinejoin="round"
			fill="none"
		/>
		<path
			d="M14 32 L 88 30"
			stroke="#2a1a1a"
			strokeWidth="0.9"
			strokeLinecap="round"
			fill="none"
			opacity="0.6"
		/>
	</svg>
);
